import './GameOverMenu.css';

const GameOverMenu = ({ score, highScore, isNewHighScore, onRestart, onMainMenu }) => {
  return (
    <div className="gameover-overlay">
      <div className="gameover-container">
        <h1 className="gameover-title">Game Over</h1>
        
        {isNewHighScore && (
          <div className="new-highscore-banner">
            <span className="trophy-large">🏆</span>
            <p>New High Score!</p>
          </div>
        )}

        <div className="score-display">
          <div className="score-item">
            <p className="score-label">Score</p>
            <p className="score-value current-score">{score}</p>
          </div>
          
          {highScore > 0 && (
            <div className="score-item">
              <p className="score-label">High Score</p>
              <p className="score-value high-score">{highScore}</p>
            </div>
          )}
        </div>

        <div className="gameover-buttons">
          <button 
            className="gameover-button gameover-button-primary" 
            onClick={onRestart}
            autoFocus
          >
            Play Again
          </button>
          <button 
            className="gameover-button gameover-button-secondary" 
            onClick={onMainMenu}
          >
            Main Menu
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameOverMenu;

